<template>
  <div class="cx_barcode_dialog">
    <b-modal  id="barcode-dialog" v-model="showInternal"  :no-close-on-backdrop="true" centered hide-header hide-footer>
        <div class="cx_barcode_outer">
          <div class="spinner spinner_body" v-if="isLoading">
              <div class="spinner-border text-info" role="status"></div>
              <span>スキャナをロードしています..</span>
          </div>                           
          <div class="cx_barcode_scanner">
            <!-- スキャナ入力待機中をバッジ表示 -->     
            <span class="cx_badge badge badge-pill badge-success" v-if="licenseValidated && readerEnabled">スキャナ入力待機中</span>            
            <!-- スキャナ -->        
            <div id="barcodeScannerUI" class="cx_scanner_container" v-if="(licenseValidated && readerEnabled) == false"> <!-- スキャナモード時はカメラ領域を非表示に変更 -->   
                <div class="dce-video-container" :class="{cx_scanner_disabled : cameraEnabled == false ||  licenseValidated == false}">
                  <span v-if ="licenseValidated == false">ライセンスが有効化されていません。「利用プラン・支払設定」で「検品デバイス数」が設定されていることを確認し、この画面を起動してください。</span>
                  <span v-if ="licenseValidated && readerEnabled && cameraEnabled">バーコードスキャナからの入力を待機中です。カメラを利用する場合は、ギアアイコンをクリックし読取デバイスを「カメラ」に変更してください。</span>
                  <span v-if ="licenseValidated && readerEnabled && cameraEnabled == false">バーコードスキャナからの入力を待機中です。バーコードスキャナがない場合は、カメラ付き携帯端末でこの画面を起動してください。</span>
                </div>   
            </div>          
      
            <!-- 読取結果 -->            
            <div class="cx_barcode_message">
              <span v-if="message">{{message}}</span>          
            </div>            
          </div>
          <!-- 商品明細画面 -->
          <div class="cx_barcode_items">
            <div class= "cx_barcode_options">
                <div  class="cx_barcode_option" >
                  <b-form-radio-group v-model="mode" buttons name="inspection-mode">
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.picking)" button-variant="outline-primary" size="lg" :value="inspectionModes.picking" :disabled="showItems || ($api.tenantSettings.inspectionMode & inspectionModes.picking) == 0">ピッキング</b-form-radio>
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.shipping)" button-variant="outline-primary" size="lg" :value="inspectionModes.shipping" :disabled="showItems || ($api.tenantSettings.inspectionMode & inspectionModes.shipping) == 0">出荷検品</b-form-radio>
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.salesOrder)" button-variant="outline-primary" size="lg" :value="inspectionModes.salesOrder" :disabled="showItems">受注検品</b-form-radio>
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.receipt)" button-variant="outline-primary" size="lg" :value="inspectionModes.receipt" :disabled="showItems || ($api.tenantSettings.inspectionMode & inspectionModes.receipt) == 0">入荷検品</b-form-radio>
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.purchaseOrder)" button-variant="outline-primary" size="lg" :value="inspectionModes.purchaseOrder" :disabled="showItems">発注検品</b-form-radio>
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.shippingRegistration)" button-variant="outline-primary" size="lg" :value="inspectionModes.shippingRegistration" :disabled="showItems">出荷登録</b-form-radio>
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.receiptRegistration)" button-variant="outline-primary" size="lg" :value="inspectionModes.receiptRegistration" :disabled="showItems">入荷登録</b-form-radio>
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.stock)" button-variant="outline-primary" size="lg" :value="inspectionModes.stock" :disabled="showItems || ($api.tenantSettings.inspectionMode & inspectionModes.stock) == 0">棚卸検品</b-form-radio>
                    <b-form-radio v-if="canShowInspectionMode(inspectionModes.stockTransferRegistration)" button-variant="outline-primary" size="lg" :value="inspectionModes.stockTransferRegistration" :disabled="showItems">移動登録</b-form-radio>
                  </b-form-radio-group>
                </div>              
                <div class="cx_barcode_option_switch"  >
                  <div v-if="pickingNo"><span class="cx_barcode_caption">ピッキング番号 : {{pickingNo}}</span></div>
                  <!-- <div v-if="showItems"><span class="cx_barcode_caption">カウントアップ</span><toggle-button v-model="autoCountUp"  :labels="{checked:'自動', unchecked:'手動'}" :width="60" :font-size="11" color="#0761AB" key="autoCountUp"/></div>     -->
                  <div v-if="!showItems && deliveryDateLabel"><span class="cx_barcode_caption">{{deliveryDateLabel}}</span><toggle-button v-model="showDeliveryDateToDay" sync :labels="{checked:'今日', unchecked:'すべて'}" :width="65" :font-size="11" color="#0761AB"/></div>                        
                  <!-- <div v-if="!showItems"><span class="cx_barcode_caption">検品済み</span><toggle-button v-model="showCompletedVoucher" sync :labels="{checked:'表示', unchecked:'非表示'}" :width="65" :font-size="11" color="#0761AB"/></div>     -->
                  <!-- <div v-if="cameraEnabled"><span class="cx_barcode_caption">読取</span><toggle-button v-model="readerEnabled" sync :labels="{checked:'スキャナ', unchecked:'カメラ'}" :width="75" :font-size="11" color="#0761AB"/></div>                                          -->
                </div>                              
            </div>
            <!-- 指示データ表示 -->
            <div class="cx_barcode_instruction">
                <div class="cx_barcode_button_left" @click="moveBack" :class="{disabled : currentId <= 0, items: showItems}"><i class="material-icons valign"  style="pointer-events:none;">arrow_left</i></div>
                <div class="cx_barcode_data spinner_parent"  v-if="!showItems">
                  <div class="spinner spinner_body" v-if="isDataLoading">
                      <div class="spinner-border text-info" role="status"></div>
                      <span>データをロードしています..</span>
                  </div>                       
                  <div v-if="selected && isScanRegistrationMode == false" class="cx_barcode_voucher" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd" :style="{left: offset + 'px'}">
                  <TextBox title="伝票番号" :value="selected.voucherNo" :enabled="false" tooltip="検品対象となる伝票番号です。検品の区分により表示される番号は異なります。左右のボタンかスワイプをすることで、別の伝票へ遷移します。"/>  
                  <TextBox v-if="mode == inspectionModes.stock || !isEnabledOrderInspection" title="倉庫" :value="selected.warehouse?selected.warehouse.name:''" :enabled="false" tooltip="検品を行う倉庫です。指定されている倉庫についての商品を検品します。"/>
                  <AtcCounterpart v-else title="倉庫" :value.sync="selected.warehouse" :needsWarehouse="true" :enabled="true" tooltip="検品を行う倉庫です。指定されている倉庫についての商品を検品します。"/>
                  <TextBox title="部門" :value="selected.segment.name" :enabled="false" tooltip="検品を行う部門です。指定されている部門についての商品を検品します。"/>         
                  <TextBox v-if="mode == inspectionModes.shipping || mode == inspectionModes.salesOrder" title="納入先" :value="selected.name" :enabled="false" tooltip="伝票で指定されている納入先です。検品を行う商品の送付先です。"/>
                  <Calendar v-if="mode == inspectionModes.shipping || mode == inspectionModes.picking"  title="出荷日" :value="selected.date" :enabled="false" tooltip="伝票で指定されている出荷日です。検品を行う商品の出荷日です。"/>                                                  
                  <Calendar v-if="mode == inspectionModes.salesOrder"  title="受注日" :value="selected.date" :enabled="false" tooltip="伝票で指定されている受注日です。"/>
                  <TextBox v-if="mode == inspectionModes.receipt || mode == inspectionModes.purchaseOrder" title="仕入先" :value="selected.name" :enabled="false" tooltip="伝票で指定されている仕入先です。検品を行う商品の仕入先です。"/>
                  <Calendar v-if="mode == inspectionModes.receipt"  title="入荷日" :value="selected.date" :enabled="false" tooltip="伝票で指定されている入荷日です。検品を行う商品の入荷日です。"/>               
                  <Calendar v-if="mode == inspectionModes.purchaseOrder"  title="発注日" :value="selected.date" :enabled="false" tooltip="伝票で指定されている発注日です。"/>
                  <Calendar v-if="mode == inspectionModes.stock"  title="棚卸日" :value="selected.date" :enabled="false" tooltip="伝票で指定されている棚卸日です。検品を行う商品の棚卸日です。"/>                                      
                  <ComboBox title="担当者" :value="selected.pic" list="userGroup" :enabled="false" tooltip="伝票で指定されている担当者です。検品した商品の担当者です。"/> 
                  <TextBox class="cx_barcode_description" :title="mode == inspectionModes.shipping ? '出荷指示':'備考'" :value="selected.description" :enabled="false" :rows="2" :tooltip="mode == inspectionModes.shipping ? '伝票に記載されている出荷指示です。出荷に関連する情報が表示されます。':'伝票で指定されている備考です。検品した商品の棚卸日です。'"/>                             
                  <Control class="cx_numric_box" title="状態" :isEdit="false" tooltip="検品データの今現在の状態が表示されており､検品を実施する事で変化します。">
                    <Badge  slot="read" :value="selected.isCompleted" list="inspectionFlags"/>            
                  </Control>                                           
                  </div>
                  <div v-if="isScanRegistrationMode" class="cx_barcode_voucher">
                  <AtcCounterpart v-if="mode == inspectionModes.shippingRegistration" title="得意先" :value.sync="registrationHeader.customer" :needsCustomer="true" :enabled="true" :required="true" tooltip="作成する出荷伝票の得意先です。"/>
                  <AtcCounterpart v-if="mode == inspectionModes.shippingRegistration" title="納入先" :value.sync="registrationHeader.receiver" :needsReceiver="true" :enabled="true" tooltip="作成する出荷伝票の納入先です。"/>
                  <AtcCounterpart v-if="mode == inspectionModes.receiptRegistration" title="仕入先" :value.sync="registrationHeader.supplier" :needsSupplier="true" :enabled="true" :required="true" tooltip="作成する入荷伝票の仕入先です。"/>
                  <AtcSegment title="部門" :value.sync="registrationHeader.segment" :enabled="true" :required="true"  :tooltip="registrationSegmentTooltip"/> 
                  <AtcCounterpart v-if="mode == inspectionModes.shippingRegistration || mode == inspectionModes.stockTransferRegistration" title="出庫倉庫" :value.sync="registrationHeader.shippingWarehouse" :needsWarehouse="true" :enabled="true" :required="true"  :tooltip="registrationShippingWarehouseTooltip"/>
                  <AtcCounterpart v-if="mode == inspectionModes.receiptRegistration || mode == inspectionModes.stockTransferRegistration" title="入庫倉庫" :value.sync="registrationHeader.receiptWarehouse" :needsWarehouse="true" :enabled="true" :required="true"  :tooltip="registrationReceiptWarehouseTooltip"/>
                  <Calendar :title="registrationDateLabel" :value.sync="registrationHeader.date" :enabled="true" :required="true" :tooltip="registrationDateTooltip"/>
                  <ComboBox title="担当者" :value.sync="registrationHeader.pic" list="userGroup" :enabled="true" :required="true" :tooltip="registrationPicTooltip"/> 
                  <TextBox v-if="mode == inspectionModes.shippingRegistration" title="出荷管理番号" :value.sync="registrationHeader.refNo" :enabled="true" tooltip="出荷伝票に登録する出荷管理番号を入力します。"/>
                  <TextBox v-if="mode == inspectionModes.receiptRegistration" title="入荷管理番号" :value.sync="registrationHeader.refNo" :enabled="true" tooltip="入荷伝票に登録する入荷管理番号を入力します。"/>
                  <TextBox v-if="mode == inspectionModes.stockTransferRegistration" title="管理番号" :value.sync="registrationHeader.refNo" :enabled="true" tooltip="在庫移動伝票に登録する管理番号を入力します。"/>
                  </div>
                </div>                         
                <div class="cx_barcode_data"  v-if="showItems">
                  <div  class="cx_barcode_voucher" v-if="selected" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd" :style="{left: offset + 'px'}">
                  <TextBox v-if="isScanRegistrationMode == false" title="明細番号" :value="selected.itemNo" :enabled="false" tooltip="検品対象の【伝票番号】に紐づく明細番号が表示されます。"/>  
                  <TextBox v-if="isScanRegistrationMode == false" title="棚番号" :value="selected.shelfNo" :enabled="false" tooltip="検品対象商品の棚番号です。【棚番号マスタ】で設定されている【棚番号】です。"/>
                  <TextBox title="商品" :value="selected.commodity.name" :enabled="false" tooltip="検品対象の商品です。SKUの指定がない場合はこの商品についてのバーコードを読み込むことで検品数量がカウントされます。"/>                  
                  <TextBox title="SKU" :value="selected.sku ? selected.sku.name:''" :enabled="false" tooltip="検品対象の商品・SKUです。表示されている商品・SKUのバーコードを読み込むことで検品数量がカウントされます。"/>         
                  <TextBox title="単位" :value="selected.uomDescription" :enabled="false" tooltip="検品対象商品の単位です。計上単位ではなく、伝票で指定されている単位が表示されます。"/>                  
                  <TextBox title="バーコード" :value="selected.barcode" :enabled="false" tooltip="商品、あるいはSKUで登録されているバーコードです。"/>        
                  <TextBox v-if="mode == inspectionModes.shippingRegistration && isMaxQuantityMode" title="最大出荷可能数量" :value="selected.maxQuantity" :enabled="false" tooltip="スキャン開始時点で在庫から計算した最大出荷可能数量です。"/>
                  <TextBox v-if="mode == inspectionModes.stockTransferRegistration && isMaxQuantityMode" title="最大移動可能数量" :value="selected.maxQuantity" :enabled="false" tooltip="スキャン開始時点で在庫から計算した最大移動可能数量です。"/>
                  <TextBox v-if="isScanRegistrationMode == false" title="指示数量" :value="selected.targetQuantity" :enabled="false" tooltip="伝票で入力されている数量です。【検品数量】が指示数量と同じ数量になることで検品が完了となります。"/>                    
                  <NumericBox title="検品数量" :value.sync="selected.scannedQuantity" tooltip="検品が行われた数量です。バーコードを読み込むと加算されます。直接入力や左右のボタンでも数量の変更ができます。">                                    
                    <Button class="qty_button" slot="before" @click="decrementQuantity"><i class="material-icons valign" style="pointer-events:none;">remove</i></Button>
                    <Button class="qty_button" slot="after" @click="incrementQuantity"><i class="material-icons valign" style="pointer-events:none;">add</i></Button>                             
                  </NumericBox>
                  <Control v-if="isScanRegistrationMode == false" class="cx_numric_box" title="数量不一致" :isEdit="true" tooltip="検品の結果、【検品数量】が【指示数量】と一致しなくても検品を完了できます。在庫数が足りないという場合に許可します。">
                        <toggle-button slot="edit" v-model="selected.allowUnmatch"  :labels="{checked:'許可', unchecked:'不許可'}" :width="70" :font-size="11" color="#0761AB" :key="mode == inspectionModes.stockTransferRegistration ? selected.barcode : selected.itemNo"/>                     
                  </Control>                
                  <!-- <Control class="cx_numric_box" title="検品除外" :isEdit="true">
                        <toggle-button slot="edit" v-model="selected.noInspection"  :labels="{checked:'除外する', unchecked:'除外しない'}" :width="100" :font-size="11" color="#0761AB"/>                     
                  </Control>     -->
                  <Control v-if="isScanRegistrationMode == false" class="cx_numric_box" title="状態" :isEdit="false" tooltip="検品データの現在の状態が表示されており､検品がされる事で変化します。">
                    <Badge  slot="read" :value="selected.isCompleted" list="inspectionFlags"/>            
                  </Control>                   
                  </div>
                  <div v-else-if="isScanRegistrationMode" class="cx_barcode_voucher">
                  <TextBox title="商品" :value="''" :enabled="false" tooltip="商品バーコードを読み込むと、ここに対象商品が表示されます。"/>
                  <TextBox title="SKU" :value="''" :enabled="false" tooltip="商品バーコードを読み込むと、ここに対象SKUが表示されます。"/>
                  <TextBox title="単位" :value="''" :enabled="false" tooltip="商品バーコードを読み込むと、ここに対象商品の単位が表示されます。"/>
                  <TextBox title="バーコード" :value="''" :enabled="false" tooltip="商品バーコードを読み込むと、ここにバーコードが表示されます。"/>
                  <TextBox v-if="mode == inspectionModes.shippingRegistration" title="最大出荷可能数量" :value="null" :enabled="false" tooltip="商品バーコードを読み込むと、ここに最大出荷可能数量が表示されます。"/>
                  <TextBox v-if="mode == inspectionModes.stockTransferRegistration" title="最大移動可能数量" :value="null" :enabled="false" tooltip="商品バーコードを読み込むと、ここに最大移動可能数量が表示されます。"/>
                  <TextBox title="検品数量" :value="null" :enabled="false" tooltip="商品バーコードを読み込むと、ここに検品数量が表示されます。"/>
                  </div>
                </div>              
                <div class="cx_barcode_button_right" @click="moveNext" :class="{disabled : !items || currentId == items.length -1, items: showItems}"><i class="material-icons valign"  style="pointer-events:none;">arrow_right</i></div>              
            </div>
          </div>
          <div class="cx_barcode_buttons">
            <b-button @click="onItemsCancel" v-if="showItems"> キャンセル</b-button>           
            <b-button @click="onItemsOk"  v-if="showItems && isOrderMode && isVoucherCompleted" variant="primary" :disabled="items.length==0 || isSaving"> 検品完了</b-button>          
            <b-button @click="onItemsOk"  v-else-if="showItems && !isOrderMode" variant="primary" :disabled="items.length==0 || isSaving"> {{isVoucherCompleted ? '検品完了': '検品中断'}}</b-button>
            <!--モバイルアプリでは閉じるボタンを非表示にする -->
            <b-button @click="onCancel" v-if="!showItems && !isBarcodeRouter"> 閉じる</b-button>
            <b-button @click="onStart"  v-if="!showItems" variant="primary" :disabled="licenseValidated==false || (isScanRegistrationMode == false && selected == null)"> 検品開始</b-button>                                     
            <b-button @click="moveToShipping"  v-if="!showItems && mode == inspectionModes.picking" variant="info" :disabled="selected == null || selected.isCompleted == false">出荷検品に移動</b-button>                     
          </div>
        </div>
        <audio ref="progress" src="@/assets/sound_progress.mp3"></audio><!-- 読み込み成功して検品数量に達していない -->
        <audio ref="success" src="@/assets/sound_success.mp3"></audio><!-- 読み込み成功して検品数量に達する -->
        <audio ref="error" src="@/assets/sound_error.mp3"></audio><!-- 読み込み失敗 -->  
    </b-modal>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import * as Dynamsoft from 'dynamsoft-barcode-reader-bundle';

enum InspectionAppModes {
  shippingAndReceipt = 'shippingAndReceipt',
  salesAndPurchaseOrder = 'salesAndPurchaseOrder',
  scanRegistration = 'scanRegistration'
}

type RegistrationHeader = {
  customer: any;
  receiver: any;
  supplier: any;
  segment: any;
  shippingWarehouse: any;
  receiptWarehouse: any;
  date: Date;
  pic: any;
  refNo: string;
};

@Component
export default class BarcodeDialog extends Vue {

  @Prop({default:false}) public isBarcodeRouter:boolean; //検品アプリ識別フラグ
  public showInternal = false;
  public mode: Common.InspectionModes = Common.InspectionModes.shipping;
  public deliveryDateLabel: string = null;  // 初期値をnullに変更
  public voucherNo: string = null;
  public warehouseId: number = 0;
  public showItems: boolean = false;
  public inspectionModes = Common.InspectionModes;
  public inspectionAppModes = InspectionAppModes;
  public cameraEnabled: boolean = false;
  public licenseValidated: boolean = false;
  public readerEnabled: boolean = false;
  public isEnabledOrderInspection: boolean = false;
  public isEnabledScanRegistration: boolean = false;
  public confirmVoucherStateOnInspectionCompleted: boolean = false;
  public registrationHeader: RegistrationHeader = { customer: null, receiver: null, supplier: null, segment: null, shippingWarehouse: null, receiptWarehouse: null, date: new Date(), pic: null, refNo: '' };
  private isInitializing: boolean = false;  // 初期化中にウォッチャを止めるためのフラグ

  private createDefaultRegistrationHeader(): RegistrationHeader {
    return {
      customer: null,
      receiver: null,
      supplier: null,
      segment: null,
      shippingWarehouse: null,
      receiptWarehouse: null,
      date: new Date(),
      pic: this.$api.auth.userId,
      refNo: ''
    };
  }

  // モードとラベルを設定するメソッドを追加
  private setInitialModeAndLabel() {
    if (this.inspectionAppMode == InspectionAppModes.scanRegistration) {
      this.mode = Common.InspectionModes.shippingRegistration;
      this.deliveryDateLabel = null;
    } else if (this.inspectionAppMode == InspectionAppModes.salesAndPurchaseOrder) {
      // 受発注モードの場合
      this.mode = Common.InspectionModes.salesOrder; // 受注検品を初期値に
      this.deliveryDateLabel = '受注日';
    } else {
      // 入出荷モード（通常モード）の場合
      this.mode = Common.InspectionModes.shipping; // 出荷検品を初期値に
      this.deliveryDateLabel = '出荷日';
    }
  }

  // public created(){
  //   if (this.isBarcodeRouter) this.show();
  // }
  public async show(){
    this.isInitializing = true;

    // showDeliveryDateToDayをキャッシュから取得。無い場合初期値はfalse
    this.showDeliveryDateToDay = localStorage.showDeliveryDateToDay ? localStorage.showDeliveryDateToDay == "true" : false;
    // ***** スマホ検品ボタン押下確認 *****
    this.$api.issueGA4trackevent(this.$route.path,'【スマホ検品】ボタン押下');
    //毎回初期化する(ライセンスの状況が同じとは限らない)
    await navigator.mediaDevices.enumerateDevices().then(devices =>{
      //カメラデバイスがあり検品デバイス数が設定されている場合にカメラゾーンを有効化する
      this.cameraEnabled = devices.filter((device) => device.kind === 'videoinput').length > 0 && this.$api.license.hasScannerLicense;
    });
    this.autoCountUp =  localStorage['autoCountUp'] != 'false'; //初期値はtrue
    this.showCompletedVoucher =  localStorage['showCompletedVoucher'] == 'true'; //初期値はfalse     
    this.readerEnabled =  localStorage['readerEnabled'] != 'false'; //カメラのライセンスの消費を抑えるため初期値はtrue
    this.isEnabledOrderInspection =  localStorage['isEnabledOrderInspection'] == 'true'; //初期値はfalse
    this.isEnabledScanRegistration =  localStorage['isEnabledScanRegistration'] == 'true' && this.$api.customFunctionOpen(this.$api.customFunctionFlags.scanRegistration); //初期値はfalse
    this.confirmVoucherStateOnInspectionCompleted = localStorage['confirmVoucherStateOnInspectionCompleted'] == 'true'; //初期値はfalse
    this.registrationHeader = this.createDefaultRegistrationHeader();

    //ロードしておかないと鳴らない
    (this.$refs.progress as HTMLAudioElement).load();
    (this.$refs.success as HTMLAudioElement).load();
    (this.$refs.error as HTMLAudioElement).load();
    this.$root.$emit('bv::hide::tooltip');    
    // console.log('test1');
    // navigator.mediaDevices.getUserMedia(null).then(()=>{console.log('found');}).catch(error => console.log('error'));
    // console.log('test2');
    //アンドロイドで不具合が発生するのでコメントアウト
    // navigator.mediaDevices.getUserMedia({ audio: false, video: true }).then(stream => console.log(JSON.stringify(stream.getVideoTracks()[0].getCapabilities())));

    if (this.$api.tenantSettings.inspectionMode == Common.InspectionModes.none){
      this.$api.modal.show('無効な操作','「システム設定」 > 「テナント設定」でスマホ検品を有効にしてください。',true,null);
      return;
    }

    
    this.validateLicense().then(()=>{
      this.showInternal = true;
      this.startScan();

      // モードとラベルの初期設定
      this.setInitialModeAndLabel();
      this.isInitializing = false;  
      this.loadVoucher(); 
      (window as any).Intercom('update', {"hide_default_launcher": true});      
    });
  }
  public close(){
    this.closeScan();
    this.showInternal = false;
      (window as any).Intercom('update', {"hide_default_launcher": false});      
  }

  public get canShowScanRegistration(): boolean {
    return this.$api.customFunctionOpen(this.$api.customFunctionFlags.scanRegistration);
  }
  
  public get inspectionAppMode(): InspectionAppModes {
    if (this.canShowScanRegistration) {
      const currentMode = localStorage['iinspectionMode'] as InspectionAppModes;
      if (currentMode == InspectionAppModes.shippingAndReceipt || currentMode == InspectionAppModes.salesAndPurchaseOrder || currentMode == InspectionAppModes.scanRegistration) {
        return currentMode;
      }
      if (localStorage['isEnabledScanRegistration'] == 'true') return InspectionAppModes.scanRegistration;
    }

    return this.isEnabledOrderInspection ? InspectionAppModes.salesAndPurchaseOrder : InspectionAppModes.shippingAndReceipt;
  }

  public canShowInspectionMode(mode: Common.InspectionModes): boolean {
    if (mode == Common.InspectionModes.stock) return true;

    if (mode == Common.InspectionModes.stockTransferRegistration) return this.canShowScanRegistration;

    if (mode == Common.InspectionModes.shippingRegistration || mode == Common.InspectionModes.receiptRegistration) {
      return this.canShowScanRegistration && this.inspectionAppMode == InspectionAppModes.scanRegistration;
    }

    if (this.canShowScanRegistration) {
      if (this.inspectionAppMode == InspectionAppModes.shippingAndReceipt) {
        return mode == Common.InspectionModes.picking || mode == Common.InspectionModes.shipping || mode == Common.InspectionModes.receipt;
      }
      if (this.inspectionAppMode == InspectionAppModes.salesAndPurchaseOrder) {
        return mode == Common.InspectionModes.salesOrder || mode == Common.InspectionModes.purchaseOrder;
      }
      return false;
    }

    return this.isEnabledOrderInspection
      ? mode == Common.InspectionModes.salesOrder || mode == Common.InspectionModes.purchaseOrder
      : mode == Common.InspectionModes.picking || mode == Common.InspectionModes.shipping || mode == Common.InspectionModes.receipt;
  }

 //------------ エラー管理 ---------------
 public suspended:boolean =false;
 public mounted(){
    this.$root.$on('bv::modal::show', this.suspendDialog);
    this.$api.formatter.ensureListLoaded('userGroup');
    //mount後にロードする
    if (this.isBarcodeRouter) this.show();    
 }
public unmounted(){
    this.$root.$off('bv::modal::show', this.suspendDialog);
}
public suspendDialog(bvModalEvent :any, modalId:any){
  //エラーダイアログが表示された場合に一旦閉じる
  if (bvModalEvent  && bvModalEvent .target.id != 'barcode-dialog' && this.suspended == false) {
    this.suspended = true;
    this.showInternal = false;
  }
}

public reopenDialog(error :any){
  //ライセンスエラー以外の場合は、再オープンする
  this.suspended = false;
  //強制終了は廃止。また子画面は閉じていないので何もする必要なし。
  // if (error.response && error.response.data && error.response.data.message){
  //     if ((error.response.data.message as String).startsWith('[ライセンスエラー]')) this.close();
  //     else this.showItems = true;
  // }
}

  //-----------  スキャナ管理 ------------  

  public isLoading: boolean = true;
  public message: string = null;
  // public get token():string{
  //   return localStorage.barcodeLicense;
  // }
  // public set token(value:string){
  //   localStorage.barcodeLicense = value;
  // }  
  public scannerElm: HTMLElement = null;
  public pScanner:Dynamsoft.BarcodeScanner = null;

  // public created(){
  //   if (! BarcodeReader.license){
  //     BarcodeReader.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMTU4MDkzLVRYbFhaV0pRY205cSIsIm9yZ2FuaXphdGlvbklEIjoiMTAxMTU4MDkzIn0=';      
  //     BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@9.0.2/dist/";
  //   }
  // }
  
  async beforeDestroy() {
    this.closeScan();
  }
  public async validateLicense(){
    // if (this.cameraEnabled == false) {
    //   this.isLoading = false;
    //   return;
    // }


    // if (! BarcodeReader.license){
    //   // BarcodeReader.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMTU4MDkzLVRYbFhaV0pRY205cSIsIm9yZ2FuaXphdGlvbklEIjoiMTAxMTU4MDkzIn0=';      
    //   BarcodeReader.license ='DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMTU4MDkzLTEwMTIxNzQzNCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMTE1ODA5MyIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOi0xNjA1MTY5MzQ5fQ==';
    //   BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@9.0.2/dist/";
    // }    
    return this.$api.execute(new Common.BarcodeLicenseValidateQuery(localStorage.barcodeLicense)).then(
      token=>{
        localStorage.barcodeLicense = token;
        this.licenseValidated = true;
      }).catch(error=>{
        //ライセンスエラーが発生した場合はスキャナを無効化する        
        // this.cameraEnabled = false;
        this.isLoading = false;
      });
  }
  public async startScan(){

    if (this.licenseValidated == false) return;

    if (this.readerEnabled) {
        document.addEventListener('keydown',this.onScanBarcodeReader);
        this.eventAttached = true;
        this.isLoading = false;
        return;  
    } else if (this.cameraEnabled == false) {
      //読取モードをカメラで保存し、カメラを取り外した後に再起動した場合は、スキャナに変更する
      this.readerEnabled = true;
      return;
    }
    　// デバッグ
      // this.isLoading = false;
      // return ;

      //携帯端末で縦使用するとカメラのwidthとheightが逆転する
      var ua = window.navigator.userAgent.toLowerCase();
      var isVertical = window.innerHeight > window.innerWidth && (ua.indexOf("android") !== -1 || ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1);     

      try{

        const config = {
          license: "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMTU4MDkzLTEwMTIxNzQzNCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMTE1ODA5MyIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOi0xNjA1MTY5MzQ5fQ==", // Replace with your Dynamsoft license key
          container: ".dce-video-container", 
          uiPath: "https://cdn.jsdelivr.net/npm/dynamsoft-barcode-reader-bundle@10.5.3000/dist/",
          scanMode: Dynamsoft.EnumScanMode.SM_MULTI_UNIQUE,
          showResultView: false,
          engineResourcePaths: {
            rootDirectory: "https://cdn.jsdelivr.net/npm/dynamsoft-barcode-reader-bundle@10.5.3000/dist/",
          },
          duplicateForgetTime:2000, //ミリ秒        
          onUniqueBarcodeScanned:  (result: any) => { this.onScan(result.text);},
          removePoweredByMessage: true,  
        }
  
        this.pScanner = new Dynamsoft.BarcodeScanner(config);
        this.pScanner.launch();        
        this.isLoading = false;
        this.$root.$emit('bv::hide::tooltip'); //念のため

      //   let scanner = await barcodescanner.launch();
      //   this.pScanner = scanner;
      //   scanner.setUIElement(document.getElementById("barcodeScannerUI"));
      //   scanner.onUniqueRead = (txt, result) => { this.onScan(txt);};        
      //   scanner.getScanSettings().then((settings)  =>{
      //       settings.whenToPlaySoundforSuccessfulRead = 'unique';
      //       settings.whenToVibrateforSuccessfulRead = 'unique';
      //       settings.duplicateForgetTime = 500; //ミリ秒
      //       settings.intervalTime = 100;//
      //       scanner.updateScanSettings(settings);            
      //   });
      //   scanner.updateVideoSettings({
      //       video: {
      //         aspectRatio: isVertical ? 0.3333: 3,
      //         width:isVertical ? 240 : 720,
      //         height:isVertical ? 720 : 240,
      //         facingMode: 'environment',
      //       }
      //   });        
      //   scanner.onPlayed = async info => {
      //       let precentW = 60;
      //       let precentH = 80;
      //       let rs = await scanner.getRuntimeSettings();
      //       rs.region.regionLeft = (100 - precentW) / 2;
      //       rs.region.regionRight = (100 + precentW) / 2;
      //       rs.region.regionTop = (100 - precentH) / 2;
      //       rs.region.regionBottom = (100 + precentH) / 2;
      //       rs.region.regionMeasuredByPercentage = 1;
      //       await scanner.updateRuntimeSettings(rs);
      //   }        
      //   await scanner.open();
      //   // await scanner.setZoom(400);        
      //   this.isLoading = false;
      //   this.$root.$emit('bv::hide::tooltip'); //念のため
      }
      catch(ex)
      {

        console.error(ex);
        this.$api.modal.show('','検品を行うためのカメラが確認できませんでした。カメラの設定を確認してください。',true,null);
        this.close();

      }
    
  }

  eventAttached : boolean = false;
  @Watch('readerEnabled')
  public onReaderEnabledChanged() {
    if (this.readerEnabled){  
        localStorage['readerEnabled'] = 'true';      
    } else {
        localStorage['readerEnabled'] = 'false';  
    }
    //再起動する
    this.closeScan();
    this.startScan();
  }
  buffer = '';
  lastTime:number = 0;
  public onScanBarcodeReader(e : KeyboardEvent){
    const now = Date.now();

    // 一定時間空いたらバッファクリア（例: 50ms）
    if (now - this.lastTime > 50) {
      this.buffer = '';
    }
    this.lastTime = now;
    console.log(e.key);
    console.log(e);
    if (e.key === 'Enter') {
      if (this.buffer.length > 0) {
        var barcode = this.buffer;
        this.buffer = '';
        console.log(barcode);
        this.$nextTick(()=>this.onScan(barcode));

      }   
    } else if (e.key.length == 1) {
      this.buffer += e.key;
    } else if (e.key != 'Shift') {
      //Shiftキーは文字コード切替で使用されるようなので除外
      //GS1制御コード(FNC1)の代替文字は機種依存があるので注意してください(設定できる機種もある)=>カスタマイズ用
      this.buffer += "[" + e.key + "]";
    }
  }

  public closeScan(){
    
    if (this.licenseValidated == false) return;

    if(this.scannerElm) { 
      (this.$refs.target as HTMLElement).removeChild(this.scannerElm);  
      this.scannerElm = null;
    }

    if (this.pScanner) {
      this.pScanner.dispose();
      this.pScanner = null;
      this.message = null;
    }

    if (this.eventAttached){
        document.removeEventListener('keydown',this.onScanBarcodeReader);
        this.eventAttached = false;
    }
  }
  
  //スキャン後の動作
  public onScan(barcode:string){

    if ((this.isScanRegistrationMode) && this.showItems == false){
      this.message = '検品開始後に商品バーコードを読み込んでください。';
      (this.$refs.error as HTMLAudioElement).play();
      return;
    }

    if (this.isScanRegistrationMode){
      var scannedBarcode = barcode?.trim();
      this.currentId = this.items.findIndex(value => (value as Common.BarcodeItem).barcode?.trim() == scannedBarcode);
      if (this.currentId != -1) {
        if (this.autoCountUp) {
          var selected = (this.items[this.currentId] as Common.BarcodeItem);
          if (this.validateMaxQuantity(selected, selected.scannedQuantity + 1, barcode) == false) return;
          selected.scannedQuantity++;
        }
        this.onCurrentIdChanged();
        this.message = String.format('【読取結果】レコードが見つかりました({0})',barcode);
        (this.$refs.progress as HTMLAudioElement).play();
        return;
      }

      var query = new Common.BarcodeItemQuery(this.mode,this.voucherNo,this.warehouseId,localStorage.barcodeLicense, barcode, this.registrationHeader);
      this.$api.execute(query).then(res => {
        var barcodeItems = (res as Common.LoadResult).result as Common.BarcodeItem[];
        if (!barcodeItems || barcodeItems.length == 0) {
          this.message = String.format('【読取結果】レコードが見つかりませんでした({0})',barcode);
          (this.$refs.error as HTMLAudioElement).play();
          return;
        }
        else if (barcodeItems.length > 1) {
          this.$api.modal.show('警告', String.format('バーコード({0})が以下の複数の商品またはSKUに重複して登録されています。\r\n{1}', barcode, this.createDuplicateBarcodeMessage(barcodeItems)), true, null);
          (this.$refs.error as HTMLAudioElement).play();
        }
        var barcodeItem = barcodeItems[0];
        barcodeItem.itemNo = '';
        if (this.validateMaxQuantity(barcodeItem, this.autoCountUp ? 1 : 0, barcode) == false) return;
        barcodeItem.scannedQuantity = this.autoCountUp ? 1 : 0;
        this.items.push(barcodeItem);
        this.currentId = this.items.length - 1;
        this.onCurrentIdChanged();
        this.message = String.format('【読取結果】レコードが見つかりました({0})',barcode);
        (this.$refs.progress as HTMLAudioElement).play();
      }).catch(error =>this.reopenDialog(error));
      return;
    }

    //対象レコードに移動する
    if (this.showItems){
      this.currentId = this.items.findIndex(value => (value as Common.BarcodeItem).barcode?.trim() == barcode); //トリム追加
      //カウントアップする      
      if (this.currentId != -1 && this.autoCountUp) {
        var selected = (this.items[this.currentId] as Common.BarcodeItem);
        selected.scannedQuantity++;
        if (selected.targetQuantity == selected.scannedQuantity)  (this.$refs.success as HTMLAudioElement).play();
        else (this.$refs.progress as HTMLAudioElement).play();    
      }
    } else {
      this.currentId = this.items.findIndex(value => (value as Common.BarcodeVoucher).voucherNo.trim() == barcode); //トリム追加
    }

    if (this.currentId == -1){
      this.message = String.format('【読取結果】レコードが見つかりませんでした({0})',barcode);
      (this.$refs.error as HTMLAudioElement).play();
    } else {
      this.message = String.format('【読取結果】レコードが見つかりました({0})',barcode);
      (this.$refs.progress as HTMLAudioElement).play();    
    }
  }

  private createDuplicateBarcodeMessage(barcodeItems: Common.BarcodeItem[]): string {
    return barcodeItems.map((item, index) => {
      const commodityName = item.commodity ? item.commodity.name : '';
      const skuName = item.sku ? item.sku.name : '';
      const itemName = skuName ? String.format('{0} / {1}', commodityName, skuName) : commodityName;
      return String.format(itemName);
    }).join('\n');
  }

  //-----------  伝票選択モード ------------
  public isDataLoading:boolean = false;
  public originalItems: Common.BarcodeVoucher[];
  public showCompletedVoucher = false;
  public pickingNo:string = null;
  public showDeliveryDateToDay:boolean = false;

  public voucherNoNames = [
      new Common.BindItem(Common.InspectionModes.picking, 'ピッキング番号'),
      new Common.BindItem(Common.InspectionModes.shipping, '出荷番号'), 
      new Common.BindItem(Common.InspectionModes.receipt, '入荷番号'), 
      new Common.BindItem(Common.InspectionModes.stock, '棚卸処理番号'),
      new Common.BindItem(Common.InspectionModes.salesOrder, '受注番号'), 
      new Common.BindItem(Common.InspectionModes.purchaseOrder, '発注番号')];
  @Watch('mode')
  public onModeChanged(newValue: Common.InspectionModes, oldValue: Common.InspectionModes){
    if (this.isInitializing || newValue == null) return; // 初期化中は発動しないようにする
    //ピッキング=>出荷検品以外の移動でフィルタをリセットする
    if (newValue != Common.InspectionModes.shipping || oldValue != Common.InspectionModes.picking) this.pickingNo = null;
    if (newValue == Common.InspectionModes.picking) {
      // this.showCompletedVoucher = true;
    }
    // else this.showCompletedVoucher = false;
    // 入出荷日当日を表示するラベル制御
    this.deliveryDateLabel = null;
    if (newValue == Common.InspectionModes.shipping) {
      this.deliveryDateLabel = '出荷日';
    }
    else if (newValue == Common.InspectionModes.receipt) {
      this.deliveryDateLabel = '入荷日';
    }
    else if (newValue == Common.InspectionModes.salesOrder) {
      this.deliveryDateLabel = '受注日';
    }
    else if (newValue == Common.InspectionModes.purchaseOrder) {
      this.deliveryDateLabel = '発注日';
    }
    this.loadVoucher();
  }

  public loadVoucher(){
    if (this.isScanRegistrationMode) {
      this.originalItems = null;
      this.resetSelector();
      this.isDataLoading = false;
      this.message = "伝票情報を入力して検品を開始してください。";
      return;
    }
    // resetItems()でフィルタを掛けるのではなく、データをロードするよう修正
    // this.originalItems = null;
    // this.resetSelector();
    // this.isDataLoading = true;
    // return this.$api.execute(new Common.BarcodeVoucherQuery(this.mode,this.pickingNo,localStorage.barcodeLicense)).then(res => {
    //   this.originalItems = res ? (res as Common.LoadResult).result : null;
    //   this.resetItems();  
    //   this.isDataLoading = false;
    //   this.message = String.format("{0}をスキャン / 左右ボタン(スワイプ)で選択",this.voucherNoNames.find(entry =>entry.value == this.mode).text);
    // }).catch(error =>this.reopenDialog(error));
  this.resetItems(); 
  }
  @Watch('showCompletedVoucher')
  @Watch('showDeliveryDateToDay')
  public resetItems(){
      if (this.isScanRegistrationMode) {
        this.originalItems = null;
        this.resetSelector();
        this.isDataLoading = false;
        this.message = "伝票情報を入力して検品を開始してください。";
        return;
      }
      // const isToday = this.showDeliveryDateToDay == true && (this.mode == Common.InspectionModes.shipping || this.mode == Common.InspectionModes.receipt);
      // this.items = this.originalItems ? this.originalItems.filter(item =>item.isCompleted == false || this.showCompletedVoucher).filter(item =>isToday==false || item.date.getTime()==new Date().getCalendarDate().getTime()):null; //フィルタする    
      // if (this.items && this.items.length > 0) this.currentId = 0;
      // else this.currentId = -1;              
      // localStorage.showDeliveryDateToDay = this.showDeliveryDateToDay;
      // this.onCurrentIdChanged();          

      localStorage.showDeliveryDateToDay = this.showDeliveryDateToDay;
      this.originalItems = null;
      this.resetSelector();
      this.isDataLoading = true;
      return this.$api.execute(new Common.BarcodeVoucherQuery(this.mode,this.pickingNo,localStorage.barcodeLicense,this.showCompletedVoucher,this.showDeliveryDateToDay)).then(res => {
        this.originalItems = res ? (res as Common.LoadResult).result : null;
        this.items = this.originalItems;
        this.isDataLoading = false;
        this.message = String.format("{0}をスキャン / 左右ボタン(スワイプ)で選択",this.voucherNoNames.find(entry =>entry.value == this.mode).text);
        if (this.items && this.items.length > 0) this.currentId = 0;
        else this.currentId = -1;         
        this.onCurrentIdChanged();
      }).catch(error =>this.reopenDialog(error));
  }
  public get isMaxQuantityMode(): boolean {
    return this.mode == Common.InspectionModes.shippingRegistration || this.mode == Common.InspectionModes.receiptRegistration || this.mode == Common.InspectionModes.stockTransferRegistration;
  }
  
  public get maxQuantityName(){
    return this.mode == Common.InspectionModes.stockTransferRegistration ? '最大移動可能数量' : '最大出荷可能数量';
  }

  private validateMaxQuantity(item: Common.BarcodeItem, quantity: number, barcode: string = ''): boolean {
    if (this.isMaxQuantityMode == false || item == null || item.maxQuantity == null) return true;
    if (quantity <= item.maxQuantity) return true;

    this.message = String.format('【読取結果】{0}({1})を超える数量は入力できません。({2})', this.maxQuantityName, item.maxQuantity, barcode || item.barcode);
    (this.$refs.error as HTMLAudioElement).play();
    return false;
  }

  @Watch('selected.scannedQuantity')
  public onSelectedScannedQuantityChanged(newValue: number, oldValue: number){
    var selectedItem = this.selected as Common.BarcodeItem;
    if (this.isMaxQuantityMode == false || selectedItem == null || selectedItem.maxQuantity == null) return;
    if (newValue <= selectedItem.maxQuantity) return;

    selectedItem.scannedQuantity = oldValue != null ? oldValue : selectedItem.maxQuantity;
    this.message = String.format('{0}({1})を超える数量は入力できません。', this.maxQuantityName, selectedItem.maxQuantity);
    (this.$refs.error as HTMLAudioElement).play();
  }

  //検品開始ボタン
  public onStart(){
    if (this.isScanRegistrationMode) {
      if ((this.mode == Common.InspectionModes.shippingRegistration && (this.registrationHeader.customer == null || this.registrationHeader.segment == null || this.registrationHeader.shippingWarehouse == null || this.registrationHeader.pic == null || this.registrationHeader.pic == '')) ||
          (this.mode == Common.InspectionModes.receiptRegistration && (this.registrationHeader.supplier == null || this.registrationHeader.segment == null || this.registrationHeader.receiptWarehouse == null || this.registrationHeader.pic == null || this.registrationHeader.pic == '')) ||
          (this.mode == Common.InspectionModes.stockTransferRegistration && (this.registrationHeader.segment == null || this.registrationHeader.shippingWarehouse == null || this.registrationHeader.receiptWarehouse == null || this.registrationHeader.pic == null || this.registrationHeader.pic == ''))) {
        this.$api.modal.show('無効な操作','必須項目を入力してください。',true,null);
        return;
      }
      this.voucherNo = '';
      this.warehouseId = this.mode == Common.InspectionModes.receiptRegistration ? this.registrationHeader.receiptWarehouse.id : this.registrationHeader.shippingWarehouse.id;
      this.resetSelector();
      this.items = [];
      this.currentId = -1;
      this.onCurrentIdChanged();
      this.showItems = true;
      this.isDataLoading = false;
      this.message = "商品をスキャン";
      return;
    }
    this.voucherNo = (this.selected as Common.BarcodeVoucher).voucherNo;
    var warehouseId =  (this.selected as Common.BarcodeVoucher).warehouse.id;
    this.warehouseId = warehouseId;
    this.resetSelector();
    this.isDataLoading = true;
    //検品開始で商品明細を取得する

    this.$api.execute(new Common.BarcodeItemQuery(this.mode,this.voucherNo,warehouseId,localStorage.barcodeLicense)).then(res => {
      this.items = (res as Common.LoadResult).result;
      if (this.items && this.items.length > 0) this.currentId = 0;
      else this.currentId = -1;              
      this.onCurrentIdChanged();
      this.showItems = true;
      this.isDataLoading = false;
      this.message = "商品をスキャン / 左右ボタン(スワイプ)で選択"      
    }).catch(error =>this.reopenDialog(error));
  }

  public moveToShipping(){
    this.pickingNo = (this.selected as Common.BarcodeVoucher).voucherNo;
    this.mode = Common.InspectionModes.shipping;
  }

  //キャンセルボタン
  public onCancel(){
    this.close();
  }

  //-----------  商品明細モード ------------

  public autoCountUp: boolean = true;
  public get isVoucherCompleted(){
    if (this.isScanRegistrationMode) return true; // 登録検品は検品中断の概念がないため、常に完了扱いとする
    return  (this.items as Common.BarcodeItem[]).filter(obj =>obj.isCompleted == false).length == 0;

  }

  public get isScanRegistrationMode(){
    return this.mode == Common.InspectionModes.shippingRegistration || this.mode == Common.InspectionModes.receiptRegistration || this.mode == Common.InspectionModes.stockTransferRegistration;
  }
  public get registrationDateLabel(){
    if (this.mode == Common.InspectionModes.shippingRegistration) return '出荷日';
    if (this.mode == Common.InspectionModes.receiptRegistration) return '入荷日';
    return '発生日';
  }
  public get registrationSegmentTooltip(){
    if (this.mode == Common.InspectionModes.shippingRegistration) return '作成する出荷伝票の部門です。';
    if (this.mode == Common.InspectionModes.receiptRegistration) return '作成する入荷伝票の部門です。';
    return '作成する在庫移動伝票の部門です。';
  }
  public get registrationShippingWarehouseTooltip(){
    if (this.mode == Common.InspectionModes.shippingRegistration) return '作成する出荷伝票の出庫倉庫です。';
    return '作成する在庫移動伝票の出庫倉庫です。';
  }
  public get registrationReceiptWarehouseTooltip(){
    if (this.mode == Common.InspectionModes.receiptRegistration) return '作成する入荷伝票の入庫倉庫です。';
    return '作成する在庫移動伝票の入庫倉庫です。';
  }
  public get registrationDateTooltip(){
    if (this.mode == Common.InspectionModes.shippingRegistration) return '作成する出荷伝票の出荷日です。';
    if (this.mode == Common.InspectionModes.receiptRegistration) return '作成する入荷伝票の入荷日です。';
    return '作成する在庫移動伝票の発生日です。';
  }
  public get registrationPicTooltip(){
    if (this.mode == Common.InspectionModes.shippingRegistration) return '作成する出荷伝票の担当者です。';
    if (this.mode == Common.InspectionModes.receiptRegistration) return '作成する入荷伝票の担当者です。';
    return '作成する在庫移動伝票の担当者です。';
  }
  public get isOrderMode(){
    return this.mode == Common.InspectionModes.salesOrder || this.mode == Common.InspectionModes.purchaseOrder;
  }
  //検品完了ボタン
  public onItemsOk(){
    // 
    if(this.isOrderMode == true && this.isVoucherCompleted == false){
      this.message="状態が検品済みになっていない明細があります。";
    }
    else{
      //検品結果をコミットする
      var query = new Common.BarcodeItemUpdateQuery(this.mode,this.voucherNo, this.items as Common.BarcodeItem[],localStorage.barcodeLicense, this.warehouseId, this.registrationHeader, this.confirmVoucherStateOnInspectionCompleted && this.isVoucherCompleted);
      if (this.isScanRegistrationMode) {
        query.registrationHeader = this.registrationHeader;
      }
      this.$api.execute(query).then(()=>
      {
        this.showItems = false;    
        this.voucherNo = null;    
        this.warehouseId = 0;
        if (this.isScanRegistrationMode) this.registrationHeader = this.createDefaultRegistrationHeader();
        this.loadVoucher();  
      }).catch(error =>this.reopenDialog(error));
    }
  }

  //キャンセルボタン
  public onItemsCancel(){
    this.showItems = false;    
    this.voucherNo = null;    
    this.warehouseId = 0;
    this.loadVoucher();
  }

  // 検品数量+ボタン
  public incrementQuantity() {
    var selectedItem = this.selected as Common.BarcodeItem;
    if (selectedItem) {
        if (this.validateMaxQuantity(selectedItem, selectedItem.scannedQuantity + 1) == false) {
          (document.activeElement as HTMLElement)?.blur();
          return;
        }
        selectedItem.scannedQuantity++;
    }
    (document.activeElement as HTMLElement)?.blur();  // プラスボタンの選択を解除
  }
  
  // 検品数量-ボタン
  public decrementQuantity() {
      var selectedItem = this.selected as Common.BarcodeItem;
      if (selectedItem && selectedItem.scannedQuantity > 0) {
          selectedItem.scannedQuantity--;
      }
      (document.activeElement as HTMLElement)?.blur();  // マイナスボタンの選択を解除
  }
  
  //-----------  レコードセレクタ(共通) ------------

  public items:Array<Common.BarcodeItem | Common.BarcodeVoucher> = null; 
  public selected : Common.BarcodeItem | Common.BarcodeVoucher = null;
  public currentId:number = -1;

  public resetSelector(){
    this.items = null;
    this.currentId = -1;
    this.selected = null;    
  }  

  @Watch('currentId')
  public onCurrentIdChanged(){
    if (this.currentId == -1 || this.items == null) this.selected = null;
    else this.selected = this.items[this.currentId];
  }
  public moveBack(){
    if (this.items && this.items.length > 0 && this.currentId > 0)this.currentId--;
  }
  public moveNext(){
    if (this.items && this.items.length > this.currentId +1)this.currentId++;
  }

  public get canMoveNext(){
    return this.items && this.items.length > this.currentId +1;
  }
  public get canMoveBack(){
    return this.items && this.items.length > 0 && this.currentId > 0;
  }
  public isTouchStarted: boolean  = false;
  public startPosition: number = 0;
  public offset: number = 0;
  public onTouchStart(e: any){
    if (this.isTouchStarted == false){
      this.isTouchStarted = true;
      this.startPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      console.log('touch started');
    }
  }
  public onTouchMove(e: any){
    if (this.isTouchStarted){
      var currentPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      this.offset = currentPosition - this.startPosition;
      if (this.offset > 0 && this.canMoveBack == false) this.offset = 0;
      else if (this.offset < 0 && this.canMoveNext == false) this.offset = 0;
    }
  }  
  public onTouchEnd(e: any){
    if (this.isTouchStarted){
      var currentPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      if (currentPosition - this.startPosition > 80 && this.canMoveBack) this.currentId -=1;
      else if (currentPosition - this.startPosition < -80 && this.canMoveNext) this.currentId +=1;
      
      this.isTouchStarted = false;
      this.offset = 0;
      console.log('touch ended {0}->{1}', this.startPosition,currentPosition);      
    }
  }  
}
</script>
<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_barcode_dialog{
  @include cx_dialog_spmode;

  //modal=>cx_layerに切り替えた際の更新漏れ(モーダル画面の最大化)
  .cx_layer {
    padding-left: unset !important;
    .modal-dialog {
      margin: 0;
      max-width: unset;    

      &.modal-dialog-centered{
        min-height: calc(100% - 3.5rem);        
      }
      &.modal-dialog-centered::before{
        height: calc(100% - 3.5rem);        
      }      
      .modal-content {
        border:none;
        border-radius: unset;
        height: var(--vh);        

        .modal-body {
          overflow-y:hidden;
          padding:0.6rem;
        }
      }
    }
  }




  .cx_barcode_outer{
    width:100%;
    height: 100%;
    overflow-y:hidden;
    display: flex;
    
    flex-direction: column;
    align-items: center;
    .cx_barcode_scanner{
      // width: calc(100vw - 34px);
      width:100%;
      display:flex;
      align-items: center;
      flex-direction: column;
      .cx_badge{
        margin-top:5px;
        font-size: 12px;
        line-height: unset;
      }
      .cx_scanner_container {
        // border: solid 1px #d3d3d3;
        aspect-ratio:3/1;
        width: 100%;
        max-width: 400px;
        height: auto;
        .dce-video-container{
          position:relative;
          aspect-ratio:3/1;
          width: 100%;
        }
        .cx_scanner_disabled{
          font-size: 14px;
          align-items: center;
          color: red;
          display: flex;
          background-color: #ebebeb;
          padding : 15px;
          span{
            text-align: left;
          }
        }
        .cx_message_hidden{
          display:none
        }
      }


      .cx_barcode_message {
        min-height: 40px;
        max-width: 450px;
        display: flex;
        font-size:12px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }


    }
    .cx_barcode_items {
      width: 100%;
      flex:1;
      display: flex;
      flex-direction: column;     
      height: 100%; 
      overflow: auto;
    }
    .cx_barcode_option{
      height: 40px;
      display:flex;
      align-items:center;
      justify-content: center;

      label {
        margin-bottom: unset;
        outline: none;
        box-shadow: none;        
        font-size: 14px;
        &.btn-outline-primary:hover:not(.active):not(.disabled){
          opacity: 0.6;
          cursor: pointer;
        }

        &.disabled:not(.active){
          color:#575757;
          border-color:#575757 ;
        }

        &.disabled.active{
          color: #ffffff;
          background-color:#575757;
          border-color:#575757 ;
        }        
      }
    }

    .cx_barcode_option_switch{
      height: 40px;
      display:flex;
      align-items:center;
      justify-content: end;        
      label {
        margin-bottom: unset;
      }      
      .cx_barcode_caption{
        font-size:12px;
        margin: 0 6px 0 8px;
      }
    }
    .cx_barcode_instruction{
      flex:1;
      border: solid 1px #d3d3d3;    
      display:flex;
      height: 100%;
      min-height:307px;
      overflow-y: hidden;
      @media screen and (max-width: 400px) {
        min-height:200px;
      }
      .cx_barcode_button_left,
      .cx_barcode_button_right{
        width:20px;
        background-color:#b63a09;
        display:flex;
        align-items: center;
        color: white;

        &.items{
          background-color: #008b8b ;          
        }

        &.disabled{ 
          opacity: 0.2;
          pointer-events: none; 
        }

        &:hover:not(.disabled){
          opacity: 0.8;      
          cursor: pointer;
        }

        .material-icons{
          font-size:20px;
        }
      }

      .cx_barcode_data{
        flex:1;
        // padding:10px 10px;      
        overflow-y:auto;
        display:flex;
        justify-content: center;
        position:relative;
        // height: 340px;
        .cx_control:not(.cx_barcode_description){
          height: 32px;
        }
        .cx_control {

          .cx_control_caption{
            width:100px;
          }
        }

        &.spinner_parent{
          position: relative;
        }

        .cx_barcode_voucher{
          position:relative;
          width:100%;
          max-width:400px;
          height: 100%;
          padding:10px;
          // position:absolute;
          @media screen and (max-width: 320px) {
            margin-left: 30px;
          }

          .cx_badge {
            line-height: 1.5;
            padding-right: 0.8rem;
            padding-left: 0.8rem;            
          }
        }

        .cx_numric_box_input{
          input {
            width: 100px;
          }
        }
        .qty_button{
          height: 22px;
          padding: 0px;
          display: flex;
          justify-content: center;
          align-items: center;

          i {margin-right: unset;}
        }
      }
    }  
    .cx_barcode_buttons{
      margin:10px 0px 0px 0px;
      bottom: 60px;
      display:flex;
      justify-content: flex-end;

      >:not(:last-child) {
        margin-right: 0.25rem;
      }    
      >:not(:first-child) {
          margin-left: 0.25rem;
      }      
    }
  }

}



</style>